import React from 'react'

const Footer = () => {
  
  const year = new Date().getFullYear();

  const handleClick = (e) => {
    e.preventDefault();
  
    const targetAttr = e.currentTarget.getAttribute('href');
    const targetElement = document.getElementById(targetAttr.substring(1));
  
    if (targetElement) {
      const location = targetElement.offsetTop;
      window.scrollTo({
        top: location - 80,
        left: 0,
        behavior: 'smooth',
      });
    }
  };

  return (
    <footer className='bg-[#0a152c] pb-2 '>
      <div className="container">
        <div className="sm:flex items-center justify-between md:gap-8">
          <div className="w-full sm:w-1/2">
            {/* <h2 className="text-[26]px leading-0 text-headingColor font-[600] mb-5 md:text-[2rem]">
            Bringing your digital dreams to life, pixel by pixel.
            </h2> */}
            {/* <a href="mailto:calmus885@gmail.com">
                <button className='flex items-center gap-2 text-white font-[600] border border-solid py-2 px-4 rounded-none border-white max-h-[35px] hover:bg-primaryColor hover:text-wite hover:font-[600] ease-in duration-300'><i className="ri-mail-send-fill"></i>Email Me</button>
              </a> */}
          </div>
          <div className='w-full sm:w-1/2'>
            {/* <p className='text-smallTextColor leading-7 mt-2 sm:mt-0'>
            I take pride in delivering exceptional digital solutions that seamlessly blend innovation, functionality, and aesthetics. With a keen eye for detail and a passion for clean code, I have crafted a diverse portfolio of projects that span across web development, mobile applications, and interactive experiences.
            </p> */}
            {/* <div className="flex items-center gap-4 flex-wrap md:gap-8 mt-10">
              <span className="text-headingColor font-[600] text-[15px]">Join me</span>
              <span className='w-35px h-35px p-1 rounded-50px text-center cursor-pointer' >
                <a href="https://github.com/shai9" target="_blank" rel="noopener noreferrer" className='text-headingColor font-[500] text-[18px]'><i className="ri-github-fill"></i></a>
              </span>
              <span className='w-35px h-35px p-1 rounded-50px text-center cursor-pointer' >
                <a href="https://twitter.com" target="_blank" rel="noopener noreferrer" className='text-headingColor font-[500] text-[18px]'><i className="ri-twitter-line"></i></a>
              </span>
              <span className='w-35px h-35px p-1 rounded-50px text-center cursor-pointer' >
                <a href="https://instagram.com/shaki.dev" target="_blank" rel="noopener noreferrer" className='text-headingColor font-[500] text-[18px]'><i className="ri-instagram-line"></i></a>
              </span>
              <span className='w-35px h-35px p-1 rounded-50px text-center cursor-pointer' >
                <a href="https://linkedIn.com" target="_blank" rel="noopener noreferrer" className='text-headingColor font-[500] text-[18px]'><i className="ri-linkedin-line"></i></a>
              </span>
            </div> */}
          </div>
        </div>
        <div className='items-center justify-center '>
            <ul className='flex items-center mt-10 justify-center gap-10 text-smallTextColor font-[500] cursor-pointer'>
            <li>
              <a onClick={handleClick} href="#about" alt='about'>About</a>
            </li>
            <li>
              <a onClick={handleClick} href="#services" alt='experience'>Services</a>
            </li>
            <li>
              <a onClick={handleClick} href="#portfolio" alt='work'>Portfolio</a>
            </li>
            <li>
              <a onClick={handleClick} href="#testimonial" alt="testimony">Testimonials</a>
            </li>
            <li>
              <a onClick={handleClick} href="#contact" alt="contact">Contact</a>
            </li>
            </ul>
          </div>
      </div>
      <div className='py-5 mt-14  text-center justify-center'>
        <div className="container">
          <p className='text-smallTextColor  text-[14px]'>Copyright {year} Developed by Dshaki - All Rights Reserved </p>
        </div>
      </div>
    </footer>
  )
}

export default Footer